import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

async function getAddonData({ axios, workshop_id }: { axios: AxiosInstance; workshop_id: number }) {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/subscription/addons`, {
    //TODO check implementation in the BE
    params: {
      workshop_id: Number(workshop_id),
    },
  });
  return data;
}

export default function useSubscriptionAddonsQuery(workshop_id: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(workshop_id),
    queryFn: () => getAddonData({ axios, workshop_id }),
    enabled: !!workshop_id,
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(workshop_id: number) {
  return ['Addons', workshop_id] as const satisfies QueryKey;
}
useSubscriptionAddonsQuery.getKey = getKey;
